import { ToastType, toast } from '@elliemae/ds-toast';
import { EXCEPTION_TOAST_CONTAINER_ID } from '../EligibilityException';

// Fixed id prevents duplicate toasts when multiple Get MI calls fail simultaneously.
const MI_ERROR_TOAST_ID = 'mi-error-singleton';

export const showMIErrorToast = (message: string): void => {
  toast(
    {
      type: ToastType.ERROR,
      messageTitle: 'Mortgage Insurance (MI)',
      messageText: message,
    },
    {
      containerId: EXCEPTION_TOAST_CONTAINER_ID,
      autoClose: false,
      toastId: MI_ERROR_TOAST_ID,
    },
  );
};
